export const PERMISSIONS_VIEWER = 0;
export const PERMISSIONS_DESIGNER = 1;
export const PERMISSIONS_CREATOR = 2;

export const EMAIL_VERIFICATION_STATUS_UNVERIFIED = 0;
export const EMAIL_VERIFICATION_STATUS_VERIFIED_BEFORE = 1;
export const EMAIL_VERIFICATION_STATUS_VERIFIED = 2;
